"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAndMergeModuleReducer = createAndMergeModuleReducer;

var _createCombinedReducer = require("./internal/create-combined-reducer");

var _storeHelper = require("./store-helper");
/**
 * Creates and merges a new Top Combined Reducer for a given moduleName
 */


function createAndMergeModuleReducer(moduleName) {
  var initialModuleState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reducer = (0, _createCombinedReducer.createCombinedReducer)(null, moduleName, initialModuleState);

  _storeHelper.storeHelper.mergeTopReducer(reducer);

  return reducer;
}